import { Box } from '@mui/material';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledOffersWrapper = styled(Box)`
  // DO NOT ADD PADDING HERE - IT WILL BREAK THE PROMOTIONS CAROUSEL
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  flex-grow: 1;

  .offers-wrapper--column-view {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    margin-top: 4px;

    & > div {
      &:hover {
        cursor: pointer;
      }
    }
  }

  .hug .carousel-item {
    padding: 6px;
  }

  .baba .carousel-item {
    padding: 6px;
  }

  .locobingo .carousel-item {
    padding: 6px;
  }

  .player-level-image {
    width: 100%;
    max-width: 1248px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 8px 8px 8px;
    margin: 0px auto;

    img {
      height: 50px;
      &:first-child {
        height: 70px;
      }

      @media only screen and (min-width: 768px) {
        height: 60px;
      }
    }
  }

  .bundle-top-container {
    width: 100%;
    height: 100%;
  }

  .bundles-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 0 16px;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &.play-simple {
      margin-top: 0;
    }

    & > *:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  .rolling-offers-wrapper {
    margin: 10px 0;
    width: 100%;
    padding: 0 16px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    flex-grow: 1;
    box-sizing: content-box;

    @media (max-width: ${breakpoints.mobileL}) {
      max-width: 400px;
      width: 90%;
    }

    & > div {
      width: 100%;
      min-width: 354px;
    }

    & > div:not(:last-child) {
      margin-bottom: 12px;
    }
  }
` as any;
